/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".data[_ngcontent-%COMP%]{display:block;width:75vw;overflow:auto}.data[_ngcontent-%COMP%]   .table[_ngcontent-%COMP%]{width:90vw;max-width:100%;overflow:auto;display:table;border-collapse:collapse;margin:0}.cCell[_ngcontent-%COMP%]{padding:0 .5vh}.customContainer[_ngcontent-%COMP%]{height:400px;overflow:auto}table[_ngcontent-%COMP%]{width:100%}.example-container[_ngcontent-%COMP%]{height:400px;max-width:100%;overflow:auto}"];
export { styles as styles };
